// App.js
// Purpose: define the top-level layout and routes so pages added easily.

import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { warmUpApi } from "./lib/api";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import WhatsAppButton from "./components/WhatsAppButton";
import { Analytics } from "@vercel/analytics/react";

import "./styles.css"; // global styles for spacing, colors, typography

export default function App() {
  // Wake the (free-tier) backend on load so the contact form is responsive
  // by the time a visitor submits it.
  useEffect(() => {
    warmUpApi();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      {/* The Navbar stays on every page */}
      <Navbar />

      {/* Main content area. The Routes below swap based on the URL */}
      <main className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          {/* You can add a 404 route later */}
        </Routes>
      </main>

      {/* The Footer stays on every page */}
      <Footer />

      {/* Floating WhatsApp button — visible on every page */}
      <WhatsAppButton />

      {/* Vercel Analytics — page views tracked automatically; conversion events fired per-component */}
      <Analytics />
    </BrowserRouter>
  );
}
